import React from 'react';
import './Resume.css';
import { GiCrownCoin, GiTrophy, GiScrollUnfurled, GiSwordman } from 'react-icons/gi';
import { MdOutlineHistory, MdOutlineMilitaryTech } from 'react-icons/md';

function Resume() {
  return (
    <div className="resume-screen">
      {/* Hero Section */}
      <div className="container-fluid py-5 d-flex align-items-center min-vh-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="content-wrapper">
                <h1 className="font-big slide-in-top">
                  Divine <span className="animate-charcter">Legacy</span>
                </h1>
                <div className="gold-bar mb-4 slide-in-bottom"></div>
                <p className="lead-text slide-in-bottom">
                  A chronicle of Kara's divine journey through the ages, from ancient battles to modern mischief.
                  Each achievement tells a story of power, wisdom, and the art of chaos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className="container-fluid timeline-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">Divine Timeline</h2>
          <div className="timeline">
            <div className="timeline-item slide-in-bottom">
              <div className="timeline-icon">
                <MdOutlineHistory />
              </div>
              <div className="timeline-content">
                <h3>The Age of Creation</h3>
                <span className="timeline-date">Before Time</span>
                <p>Born from the primordial chaos of Norse mythology, Kara emerged as a force of mischief and mayhem.</p>
              </div>
            </div>

            <div className="timeline-item slide-in-bottom">
              <div className="timeline-icon">
                <GiSwordman />
              </div>
              <div className="timeline-content">
                <h3>The Great War</h3>
                <span className="timeline-date">Ancient Times</span>
                <p>Led legendary battles against the forces of order, earning the scar that marks her wisdom.</p>
              </div>
            </div>

            <div className="timeline-item slide-in-bottom">
              <div className="timeline-icon">
                <GiCrownCoin />
              </div>
              <div className="timeline-content">
                <h3>Realm of Mischief</h3>
                <span className="timeline-date">Middle Ages</span>
                <p>Established her own realm where chaos and creativity reign supreme.</p>
              </div>
            </div>

            <div className="timeline-item slide-in-bottom">
              <div className="timeline-icon">
                <GiTrophy />
              </div>
              <div className="timeline-content">
                <h3>Modern Era</h3>
                <span className="timeline-date">Present Day</span>
                <p>Continues to shape the world through divine intervention and creative chaos.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Achievements Section */}
      <div className="container-fluid achievements-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">Divine Achievements</h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="achievement-card slide-in-bottom">
                <GiScrollUnfurled className="achievement-icon" />
                <h3>Mythical Deeds</h3>
                <ul className="achievement-list">
                  <li>Creation of the Eternal Dagger</li>
                  <li>Mastery of Reality Manipulation</li>
                  <li>Establishment of the Chaos Realm</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="achievement-card slide-in-bottom">
                <MdOutlineMilitaryTech className="achievement-icon" />
                <h3>Battle Honors</h3>
                <ul className="achievement-list">
                  <li>Victory in the Great War</li>
                  <li>Defense of the Nine Realms</li>
                  <li>Creation of Legendary Weapons</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="achievement-card slide-in-bottom">
                <GiTrophy className="achievement-icon" />
                <h3>Divine Recognition</h3>
                <ul className="achievement-list">
                  <li>Recognition as Goddess of Mischief</li>
                  <li>Master of Chaos and Order</li>
                  <li>Guardian of Creative Freedom</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Summary */}
      <div className="container-fluid skills-summary py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <h2 className="mb-4 slide-in-bottom">Divine Expertise</h2>
              <div className="skills-grid">
                <div className="skill-item slide-in-bottom">
                  <h4>Combat Mastery</h4>
                  <div className="skill-bar">
                    <div className="skill-level" style={{width: '95%'}}></div>
                  </div>
                </div>
                <div className="skill-item slide-in-bottom">
                  <h4>Magic & Sorcery</h4>
                  <div className="skill-bar">
                    <div className="skill-level" style={{width: '98%'}}></div>
                  </div>
                </div>
                <div className="skill-item slide-in-bottom">
                  <h4>Strategic Planning</h4>
                  <div className="skill-bar">
                    <div className="skill-level" style={{width: '90%'}}></div>
                  </div>
                </div>
                <div className="skill-item slide-in-bottom">
                  <h4>Reality Manipulation</h4>
                  <div className="skill-bar">
                    <div className="skill-level" style={{width: '97%'}}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resume;